import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PushNotificationsService } from './logic/push-notifications.service';
import { FcmPushNotificationsService } from './logic/fcm-push-notifications/fcm-push-notifications.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: PushNotificationsService,
      useClass: FcmPushNotificationsService
    },
  ]
})
export class PushNotificationsModule {}
